/* import axios from "../../config/axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { CiUser } from "react-icons/ci";
import { PiDownloadSimple, PiUploadSimple } from "react-icons/pi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRef } from "react";
import { TiAttachment } from "react-icons/ti";


const Referrals = () => {
    const [buttonLabel, setButtonLabel] = useState("");
    const [referrals, setReferrals] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const fetchData = async () => {
        const response = await axios.get("patients/");
        console.log("referals===>", response?.data);
        setReferrals(response?.data?.data);
    };
    const [fileUpload, setFileUpload] = useState({});

    useEffect(() => {
        fetchData();
    }, []);
    const handleFileChange = (event, rowId) => {
        console.log("file uploaded");
        console.log({ event });
        setSelectedFile(event.target.files[0]);
        setFileUpload(true);
        setUploadedFiles((prevFiles) => ({
            ...prevFiles,
            [rowId]: true, // Mark the file as uploaded for the specific row
        }));
        toast.success("File uploaded successfully!");

        // Check if fileInputRef is not null before setting its value
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };
 


    const handleUpload = async (patientId) => {
        if (!selectedFile) {
            toast.error("Please select a file before uploading.");
            return;
        }

        const formData = new FormData();
        formData.append("finalReport", selectedFile);

        try {
            const response = await axios.patch(
                `patients/report/${patientId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response?.status === 200) {
                toast.success("Report uploaded successfully!");
            }

            fetchData();
            console.log("File sent successfully!");
        } catch (error) {
            // console.error("Error uploading file:", error);
            toast.success("Report uploaded successfully!");
        }
    };


    const referralData = referrals?.map((referal) => {
        return {
            patient: (
                <div className="flex">
                    {`${referal?.firstName} ${referal?.lastName}`}
                </div>

            ),
            consultant: (
                <div className="flex">{referal?.consultant?.name} </div>
            ),
            date: new Date(referal?.createdAt).toLocaleDateString(),
            pdfURL: referal?.pdfURL,
            id: referal?._id,
            adminResponse: referal?.adminResponse,
            createdBy: referal?.createdBy,
        };
    });

    const columns = [
        {
            name: "Patient Name",
            selector: "patient",
            center: true,
            width: "170px",
            sortable: true,
        },
        {
            name: "Consultant Name",
            selector: "consultant",
            center: true,
            width: "180px",
            sortable: true,
        },
        {
            name: "Received Date",
            selector: "date",
            center: true,
            width: "180px",
            sortable: true,
        },
        {
            name: "Download",
            selector: (row) => (
                <a href={row?.pdfURL} target="blank">
                    {" "}
                    <PiDownloadSimple className="text-[#2CA1C8] text-xl" />{" "}
                </a>
            ),
            center: true,
            sortable: true,
        },
        {
            name: 'Upload Report',
            selector: (row) => (
                <div>
                    <input
                        type='file'
                        name='finalReport'
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id={`fileInput-${row?.id}`}
                    />
                    <label htmlFor={`${row?.adminResponse === true ? `fileInput-${row?.id}` : `fileInput-${row?.id}`}`}>
                        <TiAttachment className={`${row?.adminResponse === true ? "text-[#2CA1C8] text-xl" : "text-gray text-xl"}`} />
                    </label>
                </div>
            ), center: true,
            sortable: true,
            width: "180px",
        },
       
        {
            name: 'Send to Consultant',
            cell: (row) => (
                <button
                    className={`text-white ${row?.adminResponse === true ? "cursor-not-allowed" : "cursor-pointer"}`}
                    onClick={() => (row?.adminResponse !== true && handleUpload(row?.id))}
                    disabled={row?.adminResponse === "Sent"}

                    style={
                        row?.adminResponse === true
                            ? { background: 'gray', padding: '10px 30px' }
                            : { background: '#2CA1C8', padding: '10px 30px' }
                    }
                >
                    {row?.adminResponse === true ? "Sent" : "Send"}
                </button>
            ),
            background: "red",
            center: true,
            width: "220px",
            sortable: true,
        },


    ];
    return (
        <div className="container w-5/6 mx-auto">
            <ToastContainer />
            <h1 className="text-center text-3xl font-semibold mt-5 mb-2">
                Received Referrals
            </h1>
            <p className="text-center w-4/5 mx-auto mb-3">
                Here you can see a list of your recent referrals. Click ‘View’
                to see the referral in full. If you cannot see the patient you
                are looking for straight away, try clicking on the column
                headers to reorder the list. You can also use the search box to
                find a particular patient.
            </p>
            <DataTable
                columns={columns}
                data={referralData}
                pagination
                highlightOnHover
                responsive
                customStyles={{
                    headRow: {
                        style: {
                            borderTop: "1px solid #dee2e6", // Border color for the top of the header row
                            backgroundColor: "#E5F4FF",
                        },
                    },
                    headCells: {
                        style: {
                            borderRight: "1px solid #dee2e6", // Border color for the right of each header cell
                        },
                    },
                    rows: {
                        style: {
                            borderBottom: "1px solid #dee2e6", // Border color for the bottom of each row
                            backgroundColor: "gray-200",
                        },
                    },
                    cells: {
                        style: {
                            borderRight: "1px solid #dee2e6",
                        },
                    },
                }}
            />
        </div>
    );
};

export default Referrals;
 */







import React, { useEffect, useState, useRef } from "react";
import axios from "../../config/axios";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PiDownloadSimple, PiUploadSimple } from "react-icons/pi";
import { FiEdit } from "react-icons/fi";

import { Button, border } from "@chakra-ui/react";
import { TiAttachment } from "react-icons/ti";
const Referrals = () => {
    const [editDateTime, setEditDateTime] = useState({});
    const [editedDateTime, setEditedDateTime] = useState({});
    /* const handleEditDateTime = (referralId) => {
        function formatDate(dateString) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', options);
        }


        setEditDateTime(prevState => ({
            ...prevState,
            [referralId]: true,
        }));

        console.log(editDateTime);
    }; */
    const handleEditDateTime = (referralId) => {
        // Reset both date and time to empty strings
        setEditedDateTime(prevState => ({
            ...prevState,
            [referralId]: {
                date: '',
                time: ''
            }
        }));

        // Set editDateTime to true
        setEditDateTime(prevState => ({
            ...prevState,
            [referralId]: true,
        }));
    };

    const handleDateTimeChange = (referralId, type, value) => {
        setEditedDateTime(prevState => ({
            ...prevState,
            [referralId]: {
                ...prevState[referralId],
                [type]: value,
            }
        }));
    };



    /*  const handleEditDateTime = (referralId) => {
         function formatDate(dateString) {
             const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
             const date = new Date(dateString);
             return date.toLocaleDateString('en-GB', options);
         }
         setEditedDateTime({ ...editedDateTime, [referralId]: { date: '', time: '' } });
         setEditDateTime(prevState => ({
             ...prevState,
             [referralId]: true,
         }));
 
 
         console.log(editDateTime)
     }; */

    const handleSaveDateTime = (referralId) => {
        // Perform validation if needed
        // Save the edited date and time
        // For demonstration, we'll just log the edited values
        console.log("Edited Date:", editedDateTime[referralId]?.date);
        console.log("Edited Time:", editedDateTime[referralId]?.time);
        // Reset edit mode
        /* setEditDateTime(prevState => ({
            ...prevState,
            [referralId]: false,
        })); */
    };


    const [referrals, setReferrals] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [buttonColor, setButtonColor] = useState("#2CA1C8");
    const [buttonLabel, setButtonLabel] = useState("Send");
    const [buttonStates, setButtonStates] = useState({});
    const [buttonStates1, setButtonStates1] = useState({});
    const [dateInputs, setDateInputs] = useState({});
    const [currentView, setCurrentView] = useState('referrals');
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [referralsPerPage] = useState(6);

    /*  const handleDateTimeChange = (referralId, type, value) => {
         setEditedDateTime(prevState => ({
             ...prevState,
             [referralId]: {
                 ...prevState[referralId],
                 [type]: value,
             }
         }));
     }; */
    const handleButtonClick = (view) => {
        setCurrentView(view);
        console.log(view)
    };


    const fetchData = async () => {
        const response = await axios.get("referrals/");
        console.log("referrals ===> ", response?.data);
        const referrals = response?.data?.data;
        console.log(referrals)
        const matchedPatient = referrals.filter(referral => (
            referral.rf === false
        ));
        setReferrals(matchedPatient);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleFileChange = (event, rowId, pending) => {
        const selectedFile = event.target.files[0];

        console.log("first", pending)
        // Check if the selected file is a PDF
        if (selectedFile && selectedFile.type === "application/pdf") {
            if (selectedFile.size < 10485760) {
                console.log("PDF file uploaded", selectedFile.size);
                console.log({ event });


                setSelectedFile(selectedFile);

                setUploadedFiles((prevFiles) => ({
                    ...prevFiles,
                    [rowId]: true,
                }));
                console.log(uploadedFiles);
                if (pending === true) {
                    toast.success("PDF file uploaded successfully!");

                } else {
                    toast.success("Another  PDF file uploaded successfully!");

                }


                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }

            } else {
                toast.error("Please ensure that the uploaded file does not exceed 10MB in size")
            }

            // Continue with additional logic for handling the PDF file, if needed
            // For example, you may want to extract information from the PDF or perform other actions.
            // You can add that logic here.
        } else {
            // Display an error if the selected file is not a PDF
            toast.error("Please upload a PDF file.");
        }
    };

    /*  const indexOfLastReferral = currentPage * referralsPerPage;
     const indexOfFirstReferral = indexOfLastReferral - referralsPerPage;
     const currentReferrals = referrals
         ? referrals
             .filter(
                 (referral) =>
                     (referral.firstName && referral.firstName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                     (referral.lastName && referral.lastName.toLowerCase().includes(searchTerm.toLowerCase()))
             )
             .slice(indexOfFirstReferral, indexOfLastReferral)
         : []; */
    const handleUpload = async (patientId, patient) => {

        const name = patient.props.children

        const file = uploadedFiles[patientId]
        // 10 MB in bytes

        if (!file) {
            toast.error("Please select a file before uploading.");
            return;
        }

        setButtonColor("blue");
        setButtonLabel("Sent");
        setButtonStates(prevStates => ({
            ...prevStates,
            [patientId]: {
                color: "gray",
                label: "Sent"
            }
        }));
        toast.success(`Referral successfully sent back to the referee!`);

        const formData = new FormData();
        formData.append("finalReport", selectedFile);

        try {
            console.log(patientId)
            const response = await axios.patch(
                `referrals/report/${patientId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log(response);
            await new Promise(resolve => setTimeout(resolve, 1000));
            fetchData();
            console.log("File sent successfully!");
        } catch (error) {
            console.log(error);

        }
    };



    const handleUpload1 = async (patientId, patient) => {
        const appointmentDateTime = editedDateTime[patientId];
        const name = patient.props.children

        const file = uploadedFiles[patientId]

        if (!appointmentDateTime || !appointmentDateTime.date || !appointmentDateTime.time) {
            toast.error("Please select both the date and time of the appointment");
            return;
        }

        const { date, time } = appointmentDateTime;

        console.log("Appointment Date:", date);
        console.log("Appointment Time:", time);

        setButtonColor("blue");
        setButtonLabel("Sent");
        setButtonStates1(prevStates => ({
            ...prevStates,
            [patientId]: {
                color: "gray",
                label: "Sent"
            }
        }));
        toast.success(`The appointment details have been emailed to the ${name}.`);

        try {
            console.log(patientId);
            const response = await axios.patch(
                `referrals/date/${patientId}`,
                {
                    appoinmentDate: date,
                    time: time
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            console.log(response);

            await new Promise(resolve => setTimeout(resolve, 1000));
            fetchData();
            console.log("Appointment details sent successfully!");
        } catch (error) {
            console.log(error);
            console.log("Error occurred while sending appointment details");
        }
    };


    const referralData = referrals?.filter(referral =>
        (referral.title && referral.title.toLowerCase().includes(searchTerm.toLowerCase())) ||

        (referral.firstName && referral.firstName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (referral.lastName && referral.lastName.toLowerCase().includes(searchTerm.toLowerCase()))
    ).map(referral => ({
        patient: (
            <div className="flex">
                {`${referral?.title} ${referral?.firstName} ${referral?.lastName}`.length > 18
                    ? `${`${referral?.title} ${referral?.firstName} ${referral?.lastName}`.substring(0, 16)}...`
                    : `${referral?.title} ${referral?.firstName} ${referral?.lastName}`}
            </div>
        ),
        consultant: (
            <div className="flex">
                {`${referral?.consultant?.name}`.length > 14
                    ? `${`${referral?.consultant?.name}`.substring(0, 16)}...`
                    : `${referral?.consultant?.name}`}
            </div>
        ),
        /* date: new Date(referral?.createdAt).toLocaleDateString(),
        appointmentDate: referral?.appointmentDate ? new Date(referral?.appointmentDate).toLocaleDateString() : "",
         */date: new Date(referral?.createdAt).toLocaleDateString(),
        appoinmentDate: referral?.appoinmentDate ? new Date(referral?.appoinmentDate).toLocaleDateString() : "",

        name: (
            <div className="flex">
                {`${referral?.title} ${referral?.firstName} ${referral?.lastName}`.length > 18
                    ? `${`${referral?.title} ${referral?.firstName} ${referral?.lastName}`.substring(0, 16)}...`
                    : `${referral?.title} ${referral?.firstName} ${referral?.lastName}`}
            </div>
        ),

        pdfURL: referral?.pdfURL,
        time: referral?.time,
        id: referral?._id,
        adminResponse: referral?.adminResponse,
        pending: referral?.pending,
        createdBy: referral?.createdBy
    }));



    /*  const referralData = referrals?.map((referral) => {
         return {
             patient: (
                 <div className="flex">
                     {`${referral?.title}  ${referral?.firstName} ${referral?.lastName}`.length > 14
                         ? `${`${referral?.title}  ${referral?.firstName} ${referral?.lastName}`.substring(0, 16)}...`
                         : `${referral?.title}  ${referral?.firstName} ${referral?.lastName}`}
      </div>
             ),
             consultant: <div className="flex">
 
                 {`${referral?.consultant?.name}`.length > 14
                     ? `${`${referral?.consultant?.name}`.substring(0, 16)}...`
                     : `${referral?.consultant?.name}`}
 
             </div>,
             date: new Date(referral?.createdAt).toLocaleDateString(),
             appoinmentDate: referral?.appoinmentDate ? new Date(referral?.appoinmentDate).toLocaleDateString() : "",
 
             pdfURL: referral?.pdfURL,
             time: referral?.time,
             id: referral?._id,
             adminResponse: referral?.adminResponse,
             pending: referral?.pending,
             createdBy: referral?.createdBy,
         };
     }); */

    const renderAppoinmentDate = (row) => {
        const date = row.appoinmentDate ? new Date(row.appoinmentDate).toLocaleDateString() : '';
        return (
            <div>{date}</div>
        );
    };

    const renderAppoinmentTime = (row) => {
        const time = row.time ? new Date(row.time).toLocaleDateString() : '';
        return (
            <div>{time}</div>
        );
    };

    const columns = [
        {
            name: "Patient Name",
            selector: "patient",
            center: true,
            width: "170px",
            sortable: true,
        },
        {
            name: "Consultant Name",
            selector: "consultant",
            center: true,
            width: "180px",
            sortable: true,
        },
        {
            name: "Received Date",
            selector: "date",
            center: true,
            width: "180px",
            sortable: true,
        },
        {
            name: "Download",
            selector: (row) => (
                <a href={row?.pdfURL} target="_blank">
                    {" "}
                    <PiDownloadSimple className="text-[#2CA1C8] text-xl" />{" "}
                </a>
            ),
            center: true,
            sortable: true,
        },
        {
            name: "Upload Report",
            cell: (row) => (
                <div>
                    <input
                        type="file"
                        name="finalReport"
                        onChange={(event) => handleFileChange(event, row?.id, row?.pending)}
                        style={{ display: "none" }}
                        id={`fileInput-${row?.id}`}
                    />
                    <label htmlFor={`fileInput-${row?.id}`}>
                        <TiAttachment
                            className={`text-xl ${uploadedFiles[row?.id] ? "text-blue-500" : "text-gray-500"
                                }`}
                        />
                    </label>
                </div>
            ),
            center: true,
            sortable: true,
            width: "160px",
        },
        {
            name: "Send to Consultant",
            cell: (row) => (

                <button
                    className={`text-white ${buttonStates[row?.id]?.color === "gray" ? "cursor-not-allowed" : "cursor-pointer"}`}
                    onClick={() => handleUpload(row?.id, row?.name)}
                    style={{
                        background: buttonStates[row?.id]?.color || "#2CA1C8",
                        padding: "10px 30px",


                    }}
                    disabled={buttonStates[row?.id]?.color === "gray"}
                >
                    {buttonStates[row?.id]?.label || "Send"}
                </button>
            ),
            background: "red",
            center: true,
            width: "220px",
            sortable: true,
        },
    ];

    const columns1 = [
        {
            name: "Patient Name",
            selector: "patient",
            center: true,
            width: "170px",
            sortable: true,
        },
        {
            name: "Consultant Name",
            selector: "consultant",
            center: true,
            width: "180px",
            sortable: true,
        },
        {
            name: "Booking Date",
            cell: (row) => (
                <div>
                    {editDateTime[row.id] ? (
                        <>
                            <input
                                type="date"
                                name="dob"
                                placeholder="DD/MM/YYYY"
                                asp-format
                                /*                                 value={new Date(editedDateTime[row.id]?.date || new Date()).toISOString().slice(0, 10)}
                                 */
                                value={editedDateTime[row.id]?.date}
                                onChange={(e) => handleDateTimeChange(row.id, "date", e.target.value)}
                            />
                            {/* <input
                                type="date"
                                value={editedDateTime[row.id]?.date}
                                onChange={(e) => handleDateTimeChange(row.id, "date", e.target.value)}
                            /> */}
                            {/*  <input
                                type="time"
                                value={editedDateTime[row.id]?.time || row.time}
                                onChange={(e) => handleDateTimeChange(row.id, "time", e.target.value)}

                            /> */}
                            <input
                                type="time"
/*                                 value={editedDateTime[row.id]?.time || row.time}
 */                                onChange={(e) => handleDateTimeChange(row.id, "time", e.target.value)}
                                className=""
                            />

                        </>
                    ) : (
                        <>


                            <div className="mb-3">
                                {row.time === "" ? (
                                    <>
                                        {/* <input
                                            type="date"
                                            value={editedDateTime[row.id]?.date}
                                            onChange={(e) => handleDateTimeChange(row.id, "date", e.target.value)}
                                        /> */}
                                        <input
                                            type="date"

                                            asp-format
                                            /*                                             value={new Date(editedDateTime[row.id]?.date || new Date()).toISOString().slice(0, 10)}
                                             */
                                            value={editedDateTime[row.id]?.date}
                                            onChange={(e) => handleDateTimeChange(row.id, "date", e.target.value)}
                                        />
                                        <input
                                            type="time"
/*                                             value={editedDateTime[row.id]?.time || row.time}
 */                                            onChange={(e) => handleDateTimeChange(row.id, "time", e.target.value)}
                                            className=""
                                        />


                                    </>
                                ) : (
                                    <>
                                        <FiEdit
                                            className="ml-20 mt-2 text-xl text-[#2CA1C8] cursor-pointer"
                                            onClick={() => handleEditDateTime(row.id)}
                                        />
                                        {renderAppoinmentDate(row)}
                                        {row.time}
                                    </>
                                )}
                            </div>



                        </>
                    )}



                </div>
            ),
            center: true,

            sortable: true,
        }
        ,
        {
            name: "Status",
            selector: "",
            center: true,
            width: "250px",
            sortable: true,
            cell: (row) => (
                <td className="px-4 border border-[white] hover:border-gray-100 text-center text-base p-2 text-center items-center justify-center">
                    <p className={"p-2 border rounded-lg border-[#003942]"}>
                        {row?.pending == true
                            ? "Awaiting UME Report"
                            : "Completed"}
                    </p>
                </td>

            ),
        },


        {
            name: "Email Patient",
            cell: (row) => (

                <button
                    className={`   text-white ${buttonStates1[row?.id]?.color === "gray" ? "cursor-not-allowed" : "cursor-pointer"}`}
                    onClick={() => handleUpload1(row?.id, row?.name)}
                    style={{
                        background: buttonStates1[row?.id]?.color || "#2CA1C8",
                        padding: "8px 28px",
                        borderRadius: "10px",


                    }}
                    disabled={buttonStates1[row?.id]?.color === "gray"}
                >
                    {"Send confirmation to patient"}
                </button>
            ),
            background: "red",
            center: true,
            width: "280px",
            sortable: true,
        },
    ];

    /* return (
        <DataTable
            columns={columns}
            data={referralData}
            pagination
            highlightOnHover
            responsive
            customStyles={{
                headRow: {
                    style: {
                        borderTop: "1px solid #dee2e6",
                        backgroundColor: "#E5F4FF",
                    },
                },
                headCells: {
                    style: {
                        borderRight: "1px solid #dee2e6",
                    },
                },
                rows: {
                    style: {
                        borderBottom: "1px solid #dee2e6",
                        backgroundColor: "gray-200",
                    },
                },
                cells: {
                    style: {
                        borderRight: "1px solid #dee2e6",
                    },
                },
            }}
        />
    ); */



    return (
        <>
            {
                window.innerWidth < 500 ? (
                    <div className="text-center text-white p-4 bg-red-500">
                        Sorry! this portal is only operatable through desktop devices.
                    </div>
                ) : (
                    <div className="container w-5/6 mx-auto">
                        <ToastContainer />
                        <h1 className="text-center text-3xl font-semibold mt-5 mb-2">
                            Received Referrals
                        </h1>
                        <p className="text-center w-4/5 mx-auto mb-3">
                            Here you can see a list of your recent referrals. Click ‘View’ to see the
                            referral in full. If you cannot see the patient you are looking for
                            straight away, try clicking on the column headers to reorder the list.
                            You can also use the search box to find a particular patient.
                        </p>
                        <input
                            type="text"
                            placeholder="Search by Patient Name"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="text-base border flex ms-auto me-3 p-2 rounded-lg px-3 my-3"
                        />
                        {/* <input
                            type="text"
                            placeholder="Search by Patient Name"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="text-base border flex ms-auto me-3 p-2 rounded-lg px-3 my-3"

                        /> */}
                        <div className="text-center gap-20 my-3">
                            <Button
                                style={{
                                    borderRadius: '0.5rem', // Adjusted border radius
                                    padding: '0.5rem 1rem',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    border: '2px solid black', // Black border by default
                                    fontSize: '16px',
                                    backgroundColor: currentView === 'referrals' ? '#003942' : 'white',
                                    color: currentView === 'referrals' ? 'white' : '#003942',
                                }}
                                onClick={() => handleButtonClick('referrals')}
                            >
                                <span
                                    style={{
                                        position: 'absolute',
                                        width: '64px',
                                        height: '0',
                                        transition: 'all 900ms',
                                        transformOrigin: 'center',
                                        rotate: '45deg',
                                        translateX: '-20px',
                                        backgroundColor: '#003942',
                                        top: '50%',
                                    }}
                                ></span>
                                <span className="relative" style={{ transition: 'all 900ms' }}>Referrals</span>
                            </Button>

                            <Button
                                style={{
                                    marginLeft: '14px',
                                    borderRadius: '0.5rem', // Adjusted border radius
                                    padding: '0.5rem 1rem',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    border: '2px solid black', // Black border by default
                                    fontSize: '16px',
                                    backgroundColor: currentView === 'appointments' ? '#003942' : 'white',
                                    color: currentView === 'appointments' ? 'white' : '#003942',
                                }}
                                onClick={() => handleButtonClick('appointments')}
                            >
                                <span
                                    style={{
                                        position: 'absolute',
                                        width: '64px',
                                        height: '0',
                                        transition: 'all 900ms',
                                        transformOrigin: 'center',
                                        rotate: '45deg',
                                        translateX: '-20px',
                                        backgroundColor: '#003942',
                                        top: '50%',
                                    }}
                                ></span>
                                <span className="relative" style={{ transition: 'all 900ms' }}>Book Appointment</span>
                            </Button>
                        </div>





                        {currentView === 'referrals' && (

                            <DataTable
                                columns={columns}
                                data={referralData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={{
                                    headRow: {
                                        style: {
                                            borderTop: "1px solid #dee2e6", // Border color for the top of the header row
                                            backgroundColor: "#E5F4FF",
                                        },
                                    },
                                    headCells: {
                                        style: {
                                            borderRight: "1px solid #dee2e6", // Border color for the right of each header cell
                                        },
                                    },
                                    rows: {
                                        style: {
                                            borderBottom: "1px solid #dee2e6", // Border color for the bottom of each row
                                            backgroundColor: "gray-200",
                                        },
                                    },
                                    cells: {
                                        style: {
                                            borderRight: "1px solid #dee2e6",
                                            borderLeft: "1px solid #dee2e6",
                                        },
                                    },
                                }}
                            />
                        )}

                        {currentView === 'appointments' && (
                            /*  <DataTable
                                 columns={columns1}
                                 data={referrals} // You might want to change this to your actual appointment data
                                 pagination
                                 highlightOnHover
                                 responsive
                                 customStyles={{
                                     headRow: {
                                         style: {
                                             borderTop: "1px solid #dee2e6", // Border color for the top of the header row
                                             backgroundColor: "#E5F4FF",
                                         },
                                     },
                                     headCells: {
                                         style: {
                                             borderRight: "1px solid #dee2e6", // Border color for the right of each header cell
                                         },
                                     },
                                     rows: {
                                         style: {
                                             borderBottom: "1px solid #dee2e6", // Border color for the bottom of each row
                                             backgroundColor: "gray-200",
                                         },
                                     },
                                     cells: {
                                         style: {
                                             borderRight: "1px solid #dee2e6",
                                         },
                                     },
                                 }}
                             /> */

                            <DataTable
                                columns={columns1}
                                data={referralData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={{
                                    headRow: {
                                        style: {
                                            borderTop: "1px solid #dee2e6", // Border color for the top of the header row
                                            backgroundColor: "#E5F4FF",
                                        },
                                    },
                                    headCells: {
                                        style: {
                                            borderRight: "1px solid #dee2e6", // Border color for the right of each header cell
                                        },
                                    },
                                    rows: {
                                        style: {
                                            borderBottom: "1px solid #dee2e6", // Border color for the bottom of each row
                                            backgroundColor: "gray-200",
                                        },
                                    },
                                    cells: {
                                        style: {
                                            borderRight: "1px solid #dee2e6",
                                            borderLeft: "1px solid #dee2e6",
                                            /*  */
                                        },
                                    },
                                }}
                            />)}

                        {/* <DataTable
                                columns={columns}
                                data={referralData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={{
                                    headRow: {
                                        style: {
                                            borderTop: "1px solid #dee2e6", // Border color for the top of the header row
                                            backgroundColor: "#E5F4FF",
                                        },
                                    },
                                    headCells: {
                                        style: {
                                            borderRight: "1px solid #dee2e6", // Border color for the right of each header cell
                                        },
                                    },
                                    rows: {
                                        style: {
                                            borderBottom: "1px solid #dee2e6", // Border color for the bottom of each row
                                            backgroundColor: "gray-200",
                                        },
                                    },
                                    cells: {
                                        style: {
                                            borderRight: "1px solid #dee2e6",
                                        },
                                    },
                                }}
                            />
                            <DataTable
                                columns={columns1}
                                data={referralData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={{
                                    headRow: {
                                        style: {
                                            borderTop: "1px solid #dee2e6", // Border color for the top of the header row
                                            backgroundColor: "#E5F4FF",
                                        },
                                    },
                                    headCells: {
                                        style: {
                                            borderRight: "1px solid #dee2e6", // Border color for the right of each header cell
                                        },
                                    },
                                    rows: {
                                        style: {
                                            borderBottom: "px solid #dee2e6", // Border color for the bottom of each row
                                            backgroundColor: "gray-200",
                                            height: "70px",
                                        },
                                    },
                                    cells: {
                                        style: {
                                            borderRight: "1px solid #dee2e6",
                                        },
                                    },
                                }}
                            /> */}

                    </div>
                )}</>
    );
};

export default Referrals;